export default __webpack_public_path__ + "static/media/AlexLaar.ef9ed96c.png";